import { render, staticRenderFns } from "./Dialog_UpdateAccount.vue?vue&type=template&id=97b7a834&scoped=true&"
import script from "./Dialog_UpdateAccount.vue?vue&type=script&lang=js&"
export * from "./Dialog_UpdateAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97b7a834",
  null
  
)

export default component.exports